$( document ).ready(function() {
    $('select.js-single-option-selector').on('change', function() {
      console.log('changed')
      let currentValue = this.value;
      $(".js-single-option-selector--custom[value='"+currentValue+"']").prop("checked",true);
    });
  $('.js-single-option-selector--custom').on('click', function() {
      let currentValue = $(this).attr('value');
     $("select.js-single-option-selector option[value='"+currentValue+"']").prop('selected', 'selected').change();

  });

  // For sticky
    $(document).on('change', 'select.select_variants', function() {
    
    let currentOPrice = $('option:selected', this).attr('variant_price');
    let currentImage = $('option:selected', this).attr('variant_image');
    
    let currentCPrice = $('option:selected', this).attr('variant_price-compare');
    $(this).closest('.custom--upsell-item-details').find('.upsell-original--price').html(currentOPrice);
    $(this).closest('.custom--upsell-item-details').find('.upsell-compare--price').html(currentCPrice);
    $(this).closest('.custom--upsell-item-details').prev('.custom--upsell-item-img').find('img').attr('src', currentImage);
    
    });
});


// LOGO MARQUEE
$('.logo_marquee_slider').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 6,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4,
      }
    },
  ]
});
// END :: LOGO MARQUEE


document.addEventListener("DOMContentLoaded", function () {
    const tocContainer = document.getElementById("table-of-contents");
    const headings = document.querySelectorAll(".toc-heading");

    if (!tocContainer || headings.length === 0) return;

    headings.forEach((heading, index) => {
        if (!heading.id) {
            heading.id = "toc-heading-" + index;
        }

        const listItem = document.createElement("li");
        const link = document.createElement("a");
        link.href = "#" + heading.id;
        link.innerText = heading.innerText;
        link.style.textDecoration = "none";

        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Remove the class from all parent divs
            document.querySelectorAll(".highlight-parent").forEach(parent => {
                parent.classList.remove("highlight-parent");
            });

            // Get the parent div of the heading
            const parentDiv = heading.closest("div");

            if (parentDiv) {
                parentDiv.classList.add("highlight-parent");
            }

            // Scroll to the heading smoothly
            heading.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });

        listItem.appendChild(link);
        tocContainer.appendChild(listItem);
    });
});
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".read-more-container").forEach(container => {
        const readMoreBtn = container.querySelector(".read-more-btn");
        const moreText = container.querySelector(".more-text");
        const readMoreText = container.querySelector(".read-more-text");

        if (readMoreBtn && moreText) {
            readMoreBtn.addEventListener("click", function () {
                if (moreText.style.display === "none" || moreText.style.display === "") {
                    moreText.style.display = "inline"; // Show the hidden text
                    readMoreText.style.webkitLineClamp = "unset"; // Remove line limit
                    readMoreBtn.innerText = readMoreBtn.innerText.replace("Read More", "Read Less"); // Change button text
                } else {
                    moreText.style.display = "none"; // Hide again
                    readMoreText.style.webkitLineClamp = "2"; // Set line limit back
                    readMoreBtn.innerText = readMoreBtn.innerText.replace("Read Less", "Read More"); // Change button text back
                }
            });
        }
    });
});